/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Driver } from '@shared/models';

export interface DriversState {
  drivers: Driver[];
  currentDriver?: Driver;
  isActionPending: boolean;
}

export const initialState: DriversState = {
  drivers: [],
  isActionPending: false
};
